export const structData = [
  [
    {
      value: 'Portfolio',
      border: 1,
      background: 0,
      bold: true,
      index: 0,
      eleProperty: [],
      textAlign: 'left'
    },
    {
      value: 'Total Cost',
      border: 0,
      background: 0,
      bold: true,
      index: 1,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Total FMV',
      border: 0,
      background: 0,
      bold: true,
      index: 2,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '总MOIC',
      border: 0,
      background: 0,
      bold: true,
      index: 3,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Fully Diluted Ownership',
      border: 0,
      background: 0,
      bold: true,
      index: 4,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'class of Share',
      border: 0,
      background: 0,
      bold: true,
      index: 5,
      eleProperty: [],
      textAlign: 'center'
    },
    {
      value: 'Initial Investment Date',
      border: 0,
      background: 0,
      bold: true,
      index: 6,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Investment Cost',
      border: 0,
      background: 0,
      bold: true,
      index: 7,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'FairValue',
      border: 0,
      background: 0,
      bold: true,
      index: 8,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'Cumulative Unrealized Appreciation(Depreciation)',
      border: 0,
      background: 0,
      bold: true,
      index: 9,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'MOIC',
      border: 0,
      background: 0,
      bold: true,
      index: 10,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: 'fully Diluted Ownership',
      border: 1,
      background: 0,
      bold: true,
      index: 11,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '本次估值方法',
      border: 0,
      background: 1,
      index: 12,
      eleProperty: [],
      textAlign: 'left'
    },
    {
      value: '最新变动估值时间',
      border: 0,
      background: 1,
      index: 13,
      eleProperty: [],
      textAlign: 'left'
    },
    {
      value: '本季度有无影响估值的事项发生',
      border: 0,
      background: 1,
      index: 14,
      eleProperty: [],
      textAlign: 'left'
    },
    {
      value: '项目估值（人民币）',
      border: 1,
      background: 1,
      index: 15,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '原始每股单价',
      border: 0,
      background: 2,
      index: 16,
      eleProperty: [],
      textAlign: 'right'
    },
    { value: '股数', border: 0, background: 2, index: 17, eleProperty: [], textAlign: 'right' },
    {
      value: '估值调整轮次',
      border: 0,
      background: 2,
      index: 18,
      eleProperty: [],
      textAlign: 'center'
    },
    {
      value: '该轮pre valuation',
      border: 0,
      background: 2,
      index: 19,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '该轮post valuation',
      border: 0,
      background: 2,
      index: 20,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '投时持股比例',
      border: 0,
      background: 2,
      index: 21,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '投后持股比例',
      border: 0,
      background: 2,
      index: 22,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '该轮price per share',
      border: 1,
      background: 2,
      index: 23,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '项目估值(人民币)',
      border: 0,
      background: 3,
      index: 24,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '记账日汇率',
      border: 0,
      background: 3,
      index: 25,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '报告日汇率',
      border: 0,
      background: 3,
      index: 26,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '汇率引起的波动率',
      border: 0,
      background: 3,
      index: 27,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '是否因汇率调整估值',
      border: 1,
      background: 3,
      index: 28,
      eleProperty: [],
      textAlign: 'right'
    },
    {
      value: '说明/备注',
      border: 1,
      background: 1,
      index: 29,
      eleProperty: [],
      textAlign: 'left'
    }
  ]
];
export const settings = {
  licenseKey: 'non-commercial-and-evaluation',
  data: [],
  rowHeaders: false,
  height: 120 + 17 * 30,
  width: '100%',
  hiddenColumns: {
    columns: [],
    indicators: true
  },
  renderAllRows: true,// 一次性渲染所有行
  viewportColumnRenderingOffset: 100,// 关闭虚拟列渲染,避免出现列高度不一致的问题 
  nestedHeaders: [
    [
      { label: 'portfolio', colspan: 1.011 },
      { label: 'FMV信息', colspan: 11.001 },
      { label: '总体信息', colspan: 4.001 },
      { label: '新一轮融资法信息', colspan: 8.001 },
      { label: '汇率影响评估', colspan: 5.001 },
      { label: '说明/备注', colspan: 1.001 }
    ],
    [
      { label: 'portfolio', colspan: 1.011 },
      { label: 'Total Cost', colspan: 1.011 },
      { label: 'Total FMV', colspan: 1.011 },
      { label: '总MOIC', colspan: 1.011 },
      { label: 'Fully Diluted Ownership', colspan: 1.011 },
      { label: 'class of Share', colspan: 1.011 },
      { label: 'Initial Investment Date', colspan: 1.011 },
      { label: 'Investment Cost', colspan: 1.011 },
      { label: 'FairValue', colspan: 1.011 },
      {
        label: 'Cumulative Unrealized Appreciation(Depreciation)',
        colspan: 1.011
      },
      { label: 'MOIC', colspan: 1.011 },
      { label: 'fully Diluted Ownership', colspan: 1.011 },
      { label: '本次估值方法', colspan: 1.012 },
      { label: '最新变动估值时间', colspan: 1.012 },
      { label: '本季度有无影响估值的事项发生', colspan: 1.012 },
      { label: '项目估值', colspan: 1.012 },
      { label: '原始每股单价', colspan: 1.013 },
      { label: '股数', colspan: 1.013 },
      { label: '估值调整轮次', colspan: 1.013 },
      { label: '该轮pre valuation', colspan: 1.013 },
      { label: '该轮post valuation', colspan: 1.013 },
      { label: '投时持股比例', colspan: 1.013 },
      { label: '投后持股比例', colspan: 1.013 },
      { label: '该轮price per share', colspan: 1.013 },
      { label: '项目估值', colspan: 1.014, key: 'otherCurrency' },
      { label: '记账日汇率', colspan: 1.014 },
      { label: '报告日汇率', colspan: 1.014 },
      { label: '汇率引起的波动率', colspan: 1.014 },
      { label: '是否因汇率调整估值', colspan: 1.014 },
      { label: '说明/备注', colspan: 1.015 }
    ]
  ],
  colWidths: Array(structData[0].length).fill(100),
  columns: Array(structData[0].length).fill({}),
  afterRenderer: (td, row, col, prop, value, cellProperties) => {
    renderStyle(td, row, col, prop, value, cellProperties);
    return td;
  }
};
export const columnMap = [
  'portFolio',
  'totalCost',
  'totalFMV',
  'totalMOIC',
  'fullyDilutedOwnership',
  'classOfShare',
  'initialInvestmentDate',
  'investmentCost',
  'fairValue',
  'cumulativeUnrealized',
  'MOIC',
  'fullyDilutedOwnership',
  'valuationMethod',
  'valuationDate',
  'valuationMatter',
  'projectValuation',
  'shareUnitPrice',
  'shareNum',
  'valuationRounds',
  'preValuation',
  'postValuation',
  'preShareScale',
  'postShareScale',
  'pricePerShare',
  'projectValuation2',
  'bookRate',
  'reportRate',
  'rateUndulate',
  'rateMatter',
  'remark'
];
export const sumMap = {
  portFolio: 0,
  totalCost: 1,
  totalFMV: 2,
  totalMOIC: 3,
  investmentCost: 7,
  fairValue: 8,
  cumulativeUnrealized: 9,
  projectValuation: 15
};
export const projectMap = {
  portFolio: 0,
  totalCost: 1,
  totalFMV: 2,
  totalMOIC: 3,
  fullyDilutedOwnership: 4
};
export const fundMap = {
  classOfShare: 5,
  initialInvestmentDate: 6,
  investmentCost: 7,
  fairValue: 8,
  cumulativeUnrealized: 9,
  MOIC: 10,
  fullyDilutedOwnership: 11,
  valuationMethod: 12,
  valuationDate: 13,
  valuationMatter: 14,
  projectValuation: 15,
  shareUnitPrice: 16,
  shareNum: 17,
  valuationRounds: 18,
  preValuation: 19,
  postValuation: 20,
  preShareScale: 21,
  postShareScale: 22,
  pricePerShare: 23,
  projectValuation2: 24,
  bookRate: 25,
  reportRate: 26,
  rateUndulate: 27,
  rateMatter: 28,
  remark: 29
};
export const precisionMap = {
  zerobit: [
    'shareNum',
    'totalCost',
    'investmentCost',
    'totalFMV',
    'fairValue',
    'cumulativeUnrealized',
    'projectValuation',
    'preValuation',
    'postValuation',
    'projectValuation2'
  ],
  twobit: ['totalMOIC', 'MOIC', 'shareUnitPrice', 'pricePerShare', 'rateUndulate'],
  fourbit: ['fullyDilutedOwnership', 'preShareScale', 'postShareScale', 'bookRate', 'reportRate']
};
function renderStyle(td, row, col, prop, value, cellProperties) {
  // if (row == 0 && col == 0) {
  //   console.log("unrealized renderer", new Date().toISOString());
  // }
  const obj = Object.assign({}, structData[row + 1][col]);
  Object.assign(td.style, obj.style);
  td.innerHTML = obj.innerHTML;
  cellProperties.readOnly = obj.readOnly;
}
